// Normalize text for loose, accent/case-insensitive matching (e.g. "lisboa"
// matches "Lisboa", "Evora" matches "Évora"). Users often type without accents.
export const normalizeText = (v) =>
  (v || '')
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, ' ');